
























import { defineComponent, ref, watch } from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';

export default defineComponent({
  name: 'ButtonFeedback',
  components: {
    SfButton
  },
  props: {
    small: { type: Boolean, default: false },
    text: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    fullWidth: { type: Boolean, default: false },
    success: { type: Boolean, default: false }
  },
  setup(props, { emit }) {
    const ADD_TIMEOUT_MS = 2000;
    const contentContainerElement = ref(null);

    const handleButtonClick = (e) => {
      emit('click', e);
    };

    watch(
      () => props.success,
      () => {
        // set button width to prevent content from shifting
        contentContainerElement.value.style.width = `${contentContainerElement.value.offsetWidth}px`;
        setTimeout(() => {
          // reset button width
          contentContainerElement.value.style.width = 'auto';
        }, ADD_TIMEOUT_MS);
      }
    );

    return {
      contentContainerElement,
      handleButtonClick
    };
  }
});
